import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

/* Layout */
import Layout from "@/layout";

/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */

export const constantRoutes = [
  {
    path: "/login",
    component: () => import("@/views/login/index"),
    hidden: true
  },

  {
    path: "/user_agreement",
    component: () => import("@/views/userAgreement/user_agreement"),
    hidden: true
  },

  {
    path: "/404",
    component: () => import("@/views/404"),
    hidden: true
  },

  {
    path: "/",
    component: Layout,
    redirect: "/dashboard",
    name: "home",
    children: [
      {
        path: "/dashboard",
        name: "dashboard",
        component: () => import("@/views/dashboard/index"),
        meta: { title: "首页", icon: "", pop: "F" }
      }
    ]
  }
];

export const asyncRouterMap = [
  {
    path: "/",
    component: Layout,
    // redirect: '/dashboard',
    name: "home",
    meta: { title: "首页", icon: "首页-0", pop: "F" },
    // alwaysShow: true, // 当二级目录只有一个时,也显示一级目录
    children: [
      {
        path: "/dashboard",
        name: "dashboard",
        component: () => import("@/views/dashboard/index"),
        meta: { title: "首页", icon: "", pop: "F" }
      }
    ]
  },

  // productManagement 产品管理
  {
    path: "/productManagement",
    component: Layout,
    name: "productManagement",
    // alwaysShow: true, // 当二级目录只有一个时,也显示一级目录
    meta: {
      title: "产品管理",
      icon: "产品管理-0",
      pop: "F"
    },
    children: [
      {
        path: "/productManagement/product_management_list",
        name: "product_management_list",
        component: () =>
          import("@/views/productManagement/product_management_list"),
        meta: { title: "产品管理", icon: "", pop: "F" }
      }
    ]
  },

  // organizationalStructure 组织架构
  {
    path: "/organizationalStructure",
    component: Layout,
    name: "organizationalStructure",
    alwaysShow: true, // 当二级目录只有一个时,也显示一级目录
    meta: {
      title: "组织架构",
      icon: "组织架构-0",
      pop: "F"
    },
    children: [
      {
        path: "/organizationalStructure/organization_and_channel_management",
        name: "organization_and_channel_management",
        component: () =>
          import("@/views/organizationalStructure/organization_and_channel_management"),
        meta: { title: "组织与渠道管理", icon: "", pop: "F" }
      },
      {
        path: "/organizationalStructure/management_of_technical_consultants",
        name: "management_of_technical_consultants",
        component: () =>
          import("@/views/organizationalStructure/management_of_technical_consultants"),
        meta: { title: "技术咨询人员管理", icon: "", pop: "F" }
      },
      {
        path: "/organizationalStructure/invite_list",
        name: "invite_list",
        hidden: true,
        component: () => import("@/views/organizationalStructure/invite_list"),
        meta: { title: "邀请管理", icon: "", pop: "F" }
      }
    ]
  },



  // customerInUse 在用客户
  {
    path: "/customerInUse",
    component: Layout,
    name: "customerInUse",
    // alwaysShow: true, // 当二级目录只有一个时,也显示一级目录
    meta: {
      title: "在用客户",
      icon: "在用客户-0",
      pop: "F"
    },
    children: [
      {
        path: "/customerInUse/customer_in_use",
        name: "customer_in_use",
        component: () => import("@/views/customerInUse/customer_in_use"),
        meta: { title: "在用客户", icon: "", pop: "F" }
      }
    ]
  },
  // businessOpportunityClient 商机客户
  {
    path: "/businessOpportunityClient",
    component: Layout,
    name: "businessOpportunityClient",
    // alwaysShow: true, // 当二级目录只有一个时,也显示一级目录
    meta: {
      title: "商机客户",
      icon: "商机客户-0",
      pop: "F"
    },
    children: [
      {
        path: "/businessOpportunityClient/business_opportunity_client",
        name: "business_opportunity_client",
        component: () =>
          import("@/views/businessOpportunityClient/business_opportunity_client"),
        meta: { title: "商机客户", icon: "", pop: "F" }
      }
    ]
  },
  // projectDelivery 项目交付
  {
    path: "/projectDelivery",
    component: Layout,
    name: "projectDelivery",
    // alwaysShow: true, // 当二级目录只有一个时,也显示一级目录
    meta: {
      title: "项目交付",
      icon: "项目交付-0",
      pop: "F"
    },
    children: [
      {
        path: "/projectDelivery/project_delivery",
        name: "project_delivery",
        component: () => import("@/views/projectDelivery/project_delivery"),
        meta: { title: "项目交付", icon: "", pop: "F" }
      }
    ]
  },

  // commissionRecord 佣金记录
  {
    path: "/commissionRecord",
    component: Layout,
    name: "commissionRecord",
    // alwaysShow: true, // 当二级目录只有一个时,也显示一级目录
    meta: {
      title: "财务中心",
      icon: "财务中心-0",
      pop: "F"
    },
    children: [
      {
        path: "/commissionRecord/commission_record",
        name: "commission_record",
        component: () => import("@/views/commissionRecord/commission_record"),
        meta: { title: "佣金记录", icon: "", pop: "F" }
      }
    ]
  },

  // withdrawalHistory 提现记录
  {
    path: "/withdrawalHistory",
    component: Layout,
    name: "withdrawalHistory",
    // alwaysShow: true, // 当二级目录只有一个时,也显示一级目录
    meta: {
      title: "提现记录",
      icon: "提现记录-0",
      pop: "F"
    },
    children: [
      {
        path: "/withdrawalHistory/withdrawal_history",
        name: "withdrawal_history",
        component: () => import("@/views/withdrawalHistory/withdrawal_history"),
        meta: { title: "提现记录", icon: "", pop: "F" }
      }
    ]
  },

  // system 系统管理
  {
    path: "/system",
    component: Layout,
    name: "system",
    alwaysShow: true, // 当二级目录只有一个时,也显示一级目录
    meta: { title: "系统管理", icon: "系统设置-0", pop: "T" },
    children: [
      {
        path: "/system/system_user",
        name: "system_user",
        component: () => import("@/views/system/system_user"),
        meta: { title: "系统用户管理", icon: "", pop: "T" }
      },
      {
        path: "/system/system_group",
        name: "system_group",
        component: () => import("@/views/system/system_group"),
        meta: { title: "系统角色管理", icon: "", pop: "T" }
      },
      {
        path: "/system/system_module",
        name: "system_module",
        component: () => import("@/views/system/system_module"),
        meta: { title: "系统模块管理", icon: "", pop: "T" }
      }
    ]
  },
  {
    path: "*",
    redirect: "/404",
    hidden: true,
    meta: { pop: "F" }
  }
  // 404 page must be placed at the end !!!
];

const createRouter = () =>
  new Router({
    // mode: 'history', // require service support
    scrollBehavior: () => ({ y: 0 }),
    // routes: constantRoutes.concat(asyncRouterMap)
    routes: constantRoutes
  });

const router = createRouter();

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}

export default router;
